import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { FDBodyText } from '@facet-wealth/design';

export const GoalSummaryOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride('title', {
    hidden: false, // This is here because BaseOverride sets it to hidden: true for title
    _component: () => Text,
    _customProps: {
      variant: 'h1',
      weight: 'medium',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textDisabled',
      align: 'center',
    },
  }, overrideReadOnly);
